export default "__VITE_ASSET__Du9Lpf7u__"